import { NextSeo } from 'next-seo';
import TheKittiesPage from '../../components/TheKittiesPage';

export default function SecondLitterPage() {
  const title = 'Second Litter - Shitty Kitties';
  const description = `Shitty Kitties Second Litter is the second Shitty Kitties collection. Second Litter is a collection of 500 programmatically generated 1/1 profile picture style NFTs of the shittiest kitties you know and love.`;

  return (
    <div>
      <NextSeo title={title} description={description} />
      <TheKittiesPage title={'Second Litter'} gen={2} />
    </div>
  );
}
